/**
 * Created by Angelika on 07.09.2017.
 */
export const MP4 = '.mp4';
export const OGG = '.ogg';
export const HLS = '.m3u8';
export const UNDEFINED_FORMAT = '';



// WEBPACK FOOTER //
// ./src/constants/formats.js